export default __webpack_public_path__ + "static/map0-d093c3382bd7666adbaa078368be5918.jpg";